import { Heading } from '@chakra-ui/react'

import { Container } from '../components/Container'
import { Section } from '../components/Section'
import { AppSelector } from '../containers/AppSelector'
import { WithAuth } from '../containers/hoc/WithAuth'
import { PageContent } from '../containers/PageContent'
import { useAuth } from '../context/AuthContext'

const IndexPageComponent = () => {
  const { user } = useAuth() ?? {}

  return (
    <PageContent sx={{ alignContent: 'center', my: 8 }}>
      <Section>
        <Container>
          <Heading
            as="h1"
            sx={{
              letterSpacing: 'tighter',
              textAlign: 'center',
              mb: { base: 4, xl: 8 },
              fontSize: {
                base: '4xl',
                xl: '5xl',
              },
              fontWeight: 'bold',
            }}
          >
            Vítejte {user?.userFullName}!
          </Heading>

          <AppSelector />
        </Container>
      </Section>
    </PageContent>
  )
}

export const IndexPage = WithAuth(IndexPageComponent)